import { StepsStep } from '@utils/enums/StepsStep.enum';

export interface PropertiesOfStep {
  next: SingleStep;
  prev?: SingleStep;
}

interface SingleStep {
  url: string;
  step: StepsStep;
}

export const getPropertiesOfStep = (
  step: StepsStep,
  Urls: Record<string, string>,
  showInsuranceStep: boolean = false,
  hasCustomPage: boolean = false,
  isRescheduling: boolean = false,
): PropertiesOfStep => {
  switch (step) {
    case StepsStep.APPOINTMENT_TYPE:
      return {
        next: {
          url: showInsuranceStep ? Urls.INSURANCE : Urls.SCHEDULE_EXAM,
          step: showInsuranceStep
            ? StepsStep.INSURANCE
            : StepsStep.SCHEDULE_EXAM,
        },
      };
    case StepsStep.INSURANCE:
      return {
        next: {
          url: Urls.SCHEDULE_EXAM,
          step: StepsStep.SCHEDULE_EXAM,
        },
        prev: {
          url: Urls.APPOINTMENT_TYPE,
          step: StepsStep.APPOINTMENT_TYPE,
        },
      };
    case StepsStep.SCHEDULE_EXAM:
      return {
        next: isRescheduling
          ? {
              url: Urls.CONTACT_DETAILS,
              step: StepsStep.CONTACT_DETAILS,
            }
          : {
              url: Urls.PATIENT_DETAILS,
              step: StepsStep.PATIENT_DETAILS,
            },
        prev: {
          url: showInsuranceStep ? Urls.INSURANCE : Urls.APPOINTMENT_TYPE,
          step: showInsuranceStep
            ? StepsStep.INSURANCE
            : StepsStep.APPOINTMENT_TYPE,
        },
      };
    case StepsStep.PATIENT_DETAILS:
      return {
        next: hasCustomPage
          ? {
              url: Urls.CUSTOM_PAGE,
              step: StepsStep.CUSTOM_PAGE,
            }
          : {
              url: Urls.CONTACT_DETAILS,
              step: StepsStep.CONTACT_DETAILS,
            },
        prev: {
          url: Urls.SCHEDULE_EXAM,
          step: StepsStep.SCHEDULE_EXAM,
        },
      };
    case StepsStep.CUSTOM_PAGE:
      return {
        next: {
          url: Urls.CONTACT_DETAILS,
          step: StepsStep.CONTACT_DETAILS,
        },
        prev: {
          url: Urls.PATIENT_DETAILS,
          step: StepsStep.PATIENT_DETAILS,
        },
      };
    case StepsStep.CONTACT_DETAILS:
      return {
        next: {
          url: Urls.TYP,
          step: StepsStep.TYP,
        },
        prev: isRescheduling
          ? {
              url: Urls.SCHEDULE_EXAM,
              step: StepsStep.SCHEDULE_EXAM,
            }
          : hasCustomPage
            ? { url: Urls.CUSTOM_PAGE, step: StepsStep.CUSTOM_PAGE }
            : {
                url: Urls.PATIENT_DETAILS,
                step: StepsStep.PATIENT_DETAILS,
              },
      };
    default:
      return {
        next: {
          url: Urls.APPOINTMENT_TYPE,
          step: StepsStep.APPOINTMENT_TYPE,
        },
      };
  }
};
